// extracted by mini-css-extract-plugin
export default {"compliance":"SecurityChapters-module--compliance--c7a17"};